module.exports = {
  ROUTE_EDIT_REQUEST: 'ROUTE_EDIT_REQUEST',
  ROUTE_EDIT_SUCCESS: 'ROUTE_EDIT_SUCCESS',
  ROUTE_EDIT_FAILURE: 'ROUTE_EDIT_FAILURE',
};
